// import fetch from '../config/fetch'
import request from '../config/axios'
import {baseUrl,authorizationUrl,xlogUrl,ys_baseUrl,baseUrlReadoo,readoo_host, baseUrlstudy,order} from '../config/env'

/**
 错误日志
 **/
export const setErrorLog = (type,user_id,soft,os,messages) => request('POST', xlogUrl, '/m/xlog',{
    type,
    user_id,
    soft,
    os,
    messages
});

/**
 分享日志
 **/
export const setShareLog = (share_url, share_from, source_url, share_config_id) => request('POST', ys_baseUrl, '/mp/share/statistics_log',{
    share_url,
    share_from,
    source_url,
    share_config_id
});

//获取课程列表
export const getClassList = (sort,class_type,learn_status,limit,page) => request('POST', ys_baseUrl , '/vk/classroom/mysubscriptions',{
    sort,
    class_type,
  learn_status,
    limit,
    page
});
/*
微课3.3版本，红包详情页
*/
export const getPacket = (act_id,page,limit) => request('POST', authorizationUrl , '/RedPacket/getRedPacketInfo',{
   act_id,
    page,
    limit
});

/**
	获取微信授权信息
**/
export const wxConfigData = (referer) => request('POST', authorizationUrl,'/WeChatRelevant/Common/sharePrerogativeWechat',{referer});

/**
 通过微信ID获取微信授权信息
 **/
export const wxConfigDataById = (wechat_id, referer) => request('POST', authorizationUrl, '/WeChatRelevant/Common/getSignPackageByWeChatId', { wechat_id, referer });

/**
 微课3.1.0版本有书豆任务中心相关
 **/
//获取任务列表
export const getTaskList = (output,plan_id) => request('POST',ys_baseUrl, '/api/task/user_tk',{
    output,
    plan_id
});

//打卡接口
export const check = (output,plan_id) => request('POST', ys_baseUrl ,'/api/task/clock',{
    output,
    plan_id
});

/**
	已订阅微课列表  2.0版本
	3.0版本为 学习页面课程列表
**/
// export const myPlanList = (type) => request('POST','','/VKclass/Classroom/home',{
//     type
// });
export const myPlanList = (page, limit, from_ysapp_name) => request('POST', ys_baseUrl,'/vk/classroom/user_course_list',{
    page, limit, from_ysapp_name
});

export const study = () => request('POST','','/VKclass/Classroom/indexList',{

});

/**
 *
拆书包列表
 **/
export const packlist = (pb_id,plan_id,page,order) => request('POST', '','/VKclass/Classroom/packList',{
    pb_id,
    plan_id,
    page,
    order
});
/**
 3.0版本中的日历下面的拆书包shuju
 */
export const todayList = (plan_id,pb_id,date) => request('POST', '','/VKclass/Classroom/middlePageDayPackList',{
    plan_id,
    pb_id,
    date,
});
/**
 往期历史
 **/
export const bookList = (plan_id,page) => request('POST', '', '/VKclass/Classroom/bookList',{
    plan_id,
    page,
});

/**
 拆书包详情
 **/
export const packInfo = (pack_id,plan_id,share_uid,signature) => request('POST', ys_baseUrl, '/vk/classroom/packInfo',{
    pack_id,
    plan_id,
    share_uid,
    signature
});

/**
 拆书包签到
 **/
export const checkIn = (pb_id,id) => request('POST', '', '/VKclass/Classroom/checkIn',{
    pb_id,
    id
});


/**
 用户信息
 **/
export const userInfo = () => request('GET', ys_baseUrl, '/vk/Classroom/myInfo',{});

/**
 意见回馈
 **/
export const saveMsg = (msg,lianxi) => request('POST', '', '/VKclass/Classroom/saveMsg',{
    msg,
    lianxi
});


/**
 计划列表
 **/
export const planList = (type,plan_type,page) => request('POST', '', '/VKclass/Classroom/hotPlanList',{
    type,
    plan_type,
    page
});

/**
 猜你喜欢 换一换
 **/
export const change_interest = (page,limit) => request('POST', ys_baseUrl, '/mp/classroom/change_interest',{
    page,
    limit
});


/**
 计划分类列表
 **/
export const getTagPlanList = (tag_id,page,limit) => request('POST', '', '/VKclass/Classroom/tagPlanList',{
    tag_id,
    page,
    limit
});

/**
 banner列表
 **/
export const bannerList = () => request('POST', '', '/VKclass/Classroom/bannerList',{});

/**
 * 计划学习数据
 **/
export const getLearnSpace = (plan_id,output='json') => request('POST', ys_baseUrl, '/vk/classroom/learnspace',{
    plan_id,output
});

/**
 * 训练营计划学习数据
 **/
export const getLive = (plan_id,output='json') => request('GET', ys_baseUrl, '/vk/classroom/get_plan_live',{
    plan_id,output
});

/**
 * 计划学习数据
 **/
export const getBeforCourse = (plan_id,pb_id,order_type,page,limit,output='json') => request('POST', ys_baseUrl, '/vk/classroom/beforecourse',{
    plan_id,
    pb_id,
    order_type,
    page,
    limit,
    output
});

/**
 * 计划学习作业数据-新
 **/
 export const getClassWorkList = (plan_id,order_type,output='json') => request('POST', ys_baseUrl, '/vk/classroom/work_list',{
    plan_id,
    order_type,
    output
});

/**
 * 学习页
 **/
export const getExpandmenu = (plan_id,output='json') => request('POST', ys_baseUrl, '/vk/classroom/getexpandmenu',{
    plan_id,
    output
});

/**
 * 学习拆书包目录
 **/
export const getStartLearnPage = (plan_id) => request('POST', '', '/VKclass/Classroom/startLearnPage',{
    plan_id
});

/**
 * 学习页直播card数据获取
 **/
export const getStudyLiveCard = (plan_id) => request('GET', baseUrl, '/api/yz/plan/live_banner',{
    plan_id
});

/**
 * 学习拆书包列表
 **/
export const getLearnPackList = (plan_id) => request('POST', '', '/VKclass/Classroom/learnPackList',{
    plan_id
});

/**
 * 签到卡片信息
 **/
export const getCheckCardInfo = (plan_id,share_uid,time_stamp_share,utm_str,pack_id,pb_id) => request('POST', ys_baseUrl, '/vk/classroom/check_card',
pack_id && pb_id ? {
    plan_id,
    pack_id,
    pb_id,
    share_uid,
    time_stamp_share,
    utm_str
} : {
    plan_id,
    share_uid,
    time_stamp_share,
    utm_str
});

/**
 * 学习拆书包列表详情
 **/
export const getPackDetail = (plan_id,pb_id,pack_id) => request('POST', ys_baseUrl, '/vk/classroom/packdetail',{
    plan_id,
    pb_id,
    pack_id
});

/**
 * 阅读时长
 **/
export const packReadTime = (pack_id,read_time) => request('POST', '', '/VKclass/Classroom/packReadTime',{
    pack_id,
    read_time
});

/**
 * 分享成功后签到
 **/
export const getCheckIn = (id,pb_id,plan_id) => request('POST', '', '/VKclass/Classroom/checkIn',{
    id,
    pb_id,
    plan_id
});

/**
 * 学习日历
 **/
export const getStudyCalendar = (plan_id,date) => request('POST', ys_baseUrl, '/vk/classroom/studyCalendar',{
    plan_id,
    date
});

/**
 * 学习日历
 **/
export const getDateStudy = (plan_id,pb_id,pack_id,date) => request('POST', ys_baseUrl, '/vk/classroom/todayStudy',{
    plan_id,
    pb_id,
    pack_id,
    date
});

/**
 * 分销详情 (分销排行)
 **/
export const getPlanDistributionInfo = (plan_id) => request('POST', '', '/VKclass/Distribution/planDistributionInfo',{
    plan_id
});

/**
 * 优惠券列表
 **/
export const getmyCouponInfo = (plan_id,page,limit) => request('POST', '', '/VKclass/Distribution/myCouponInfo',{
    plan_id,
    page,
    limit
});

/**
 * 普通计划签到接口
 **/
export const setUserPlanCheck = (plan_id,time_stamp) => request('POST', ys_baseUrl, '/vk/classroom/user_plan_check',{
    plan_id,
    time_stamp
});

/**
 * 普通计划签到接口
 **/
export const setUserPlanShare = (plan_id,date,time_stamp) => request('POST', '', '/VKclass/Package/userPlanShare',{
    plan_id,
    date,
    time_stamp
});

/**
 * 普通计划签到卡片数据
 **/
export const getOrdinaryCheckCardInfo = (plan_id,share_uid,user_id) => request('POST', '', '/VKclass/Classroom/ordinaryCheckCardInfo',{
    plan_id,
    share_uid,
    user_id
});

/**
 * 系统弹窗接口
 **/
export const getHomeAlert = (udid, page_name) => request('GET', baseUrl, '/api/yz/mkpop/bullet_window',{
    udid, page_name
});

/**
 * 系统弹窗接口
 **/
export const getHomeAlertV2 = (udid, page_name) => request('GET', baseUrl, '/api/yz/mkpop/bullet_window_v2',{
    udid, page_name
});

/**
 * 统计时长接口
 **/
export const setPackReadTime = (plan_id,pb_id,pack_id,type,read_time,business_code) => request('POST', '', '/VKclass/Package/setPackReadTime',{
    plan_id,
    pb_id,
    pack_id,
    type,
    read_time,
    business_code
});

/**
 * 统计时长接口（新）
 * date 2020-01-19
 **/
export const saveStudayTime = (type, pack_time, from, business_code) => request('POST', baseUrlstudy, '/w/pack/readtime',{
    type, pack_time, from, business_code
});

/**
 * 计划补签功能
 **/
export const checkOtherDay = (user_id,plan_id, is_clock,time_stamp) => request('POST', '', '/w/plan/check',{
    user_id,
    plan_id,
    is_clock,
    time_stamp
});

/**
 * 成就卡
 **/
export const getCertificateInfo = (plan_id,pb_id,user_id) => request('GET',ys_baseUrl, '/api/certificate/page',{
    plan_id,
    pb_id,
    user_id,
    output: 'json'
});

/**
 * 新成就卡
 **/
export const getChengjiuCardInfo = (plan_id,share_uid,plan_stage) => request('POST',ys_baseUrl, '/vk/certificate/achievementCard',{
    plan_id,
    share_uid,
    plan_stage,
    output: 'json'
});

/**
 * 排行榜】
 * @plan_id： 计划id
 * @rank_type: accumulative个人学霸,continuity个人坚持, group班级
 * @share_uid: 分享者id
 **/
 export const rankingList = (plan_id, rank_type, share_uid, page, limit) => request('POST',ys_baseUrl, '/vk/classroom/rank_list',{
     plan_id,
     rank_type,
     share_uid,
     page,
     limit,
     output: 'json'
 });

/**
 * 签到卡片预览
 **/
export const showClockConfig = (id) => request('POST',ys_baseUrl, '/api/trainingcamp/showclockconfig',{
    id
});

/**
 * 获取计划书籍列表
 **/
export const getPlanBookList = (plan_id) => request('POST',ys_baseUrl, '/vk/classroom/user_plan_book',{
    plan_id
});


/**
 * 获取计划书籍详情
 **/
export const getPlanBookInfo = (plan_id,pb_id) => request('POST',ys_baseUrl, '/vk/classroom/plan_book_intro',{
    plan_id,
    pb_id
});

/**
 * 发现页共读数据
 **/
export const getThemeReading = () => request('POST',ys_baseUrl, '/mp/gd/find/findInfo',{});

/**
 * 通用学习页数据
 **/
export const getBeforeThemeReading = (plan_id,pb_id) => request('POST',ys_baseUrl, '/mp/gd/book/info',{
    plan_id,
    pb_id
});

/**
 * 普通课程直播数据
 * 接口文档 https://confluence.youshu.cc/pages/viewpage.action?pageId=264273978
 **/
export const getPlanLive = (plan_id, live_display_type, sort_type) => request('GET',baseUrlstudy, '/vk/classroom/plan_live',{
    plan_id,
    live_display_type,
    sort_type
});

/**
 * 报名预约直播
 * 接口文档 https://confluence.youshu.cc/pages/viewpage.action?pageId=27853727
 **/
export const liveEnroll = (live_id) => request('POST', baseUrlstudy, '/w/live/enroll',{
    live_id
});

/**
 * 获取公众号关注状态
 * 接口文档 http://confluence.youshu.cc:9081/pages/viewpage.action?pageId=167051319
 **/
 export const wechatSubscribe = () => request('GET',baseUrlstudy, '/w/live/wechat_subscribe',{
    
});

/**
 * 通用往期数据
 **/
export const geteforebookpack = (plan_id,pb_id,order_type,page,limit) => request('POST',ys_baseUrl, '/mp/gd/book/bookpack',{
    plan_id,
    pb_id,
    order_type,
    page,
    limit
});

/**
 * 分班数据
 **/
export const joinClass = (data) => request('POST',ys_baseUrl, '/api/class/join',{
    ...data
});


/**
 * 获取商品购买地址
 **/
export const getBuyInfo = (data) => request('GET',ys_baseUrl, '/api/class/get_buy_info',{
    ...data
});



/**
 * 报道接口
 **/
export const getReport = (class_id,stage_id) => request('POST',ys_baseUrl, '/api/class/report',{
    class_id,
    stage_id
});

/**
 * 保存头像接口
 **/
export const saveAvatar = (avatar) => request('POST',ys_baseUrl, '/vk/user/saveInfo',{
    avatar
});

/**
 * 获取分享配置信息
 **/
export const getBusinessConfig = (business_url_id, business_code, business_identification) => request('POST',ys_baseUrl, '/mp/share/business_config',{
    business_url_id, business_code, business_identification
});

/**
 * 读书计划书籍列表
 **/
export const getBookList = (plan_id) => request('GET',ys_baseUrl, '/vk/reading_plan/book_list',{
    plan_id
});


/*
   音频播放列表
*/
export const playList = (plan_id, pb_id) => request('POST', ys_baseUrl, '/vk/reading_plan/play_list', {
    plan_id, pb_id
})

/**
 获取老师端用户作业-提交点评
 **/
export const saveComment = (comment_type, answer_id, com_content, media, media_time, pid, receive_user) => request('POST',ys_baseUrl, '/mp/vk_task/comment',{
    comment_type,
    answer_id,
    com_content,
    media,
    media_time,
    pid,
    receive_user
});

/**
我的订单列表
**/
export const orderList = (page,limit, h5_version) => request('POST', order, '/w/trade/record', {
    page,limit, h5_version
});

/**
获取计划打卡奖励配置
**/
export const get_clock_reward = (goods_type, goods_id) => request('GET', ys_baseUrl, '/mp/training_camp/clock_reward_config', {
    goods_type, goods_id
});

/**
 获取优惠券
 **/
export const getWomanExchangeCoupon = (user_id, coupon_id) => request('POST', authorizationUrl, '/Coupon/WomanExchangeCoupon', {
    user_id,
    coupon_id
});

/*
   结算页余额支付
*/
export const accountPay = (pay_fee, total_fee, pay_type, pay_data, coins, pay_source, pay_os) => request('POST', baseUrlstudy, '/VKclass/Classroom/accountPay', {
    pay_fee,
    total_fee,
    pay_type,
    pay_data,
    coins,
    pay_source,
    pay_os
})

/*
   获取资源位信息
*/
export const getResourceInfo = (udid, page_name) => request('GET', baseUrl, '/api/yz/mkpop/banner', {
    udid, page_name
})

/*
   获取资源位信息
*/
export const getResourceInfoV2 = (udid, page_name) => request('GET', baseUrl, '/api/yz/mkpop/banner_v2', {
    udid, page_name
})
/*

/*
   获取结课报告的分享海报数据
*/
export const getPosterInfo = (plan_id) => request('GET', ys_baseUrl, '/vk/classroom/finalReport', {
    plan_id
})

/*
   获取优惠券信息
*/
export const getCouponInfo = (coupon_id) => request('GET', ys_baseUrl, '/Coupon/getInfoByCouponId', {
    coupon_id
})

/*
   退出登录
*/
export const logout = () => request('GET', ys_baseUrl, '/mp/classroom/logout', {})

/**
 本周学习列表
 **/
export const weekLearnList = (date) => request('GET',ys_baseUrl, '/vk/classroom/week_learn',{
  date
});
/**
 猜你喜欢数据
 **/
export const getGuessList = () => request('GET',ys_baseUrl, '/vk/classroom/get_interest_course',{

});

/**
 获取学习页面配置信息
 **/
export const getPageCardInfo = (page_id) => request('GET', baseUrl, '/api/yz/page',{
    page_id
});

/**
 获取训练营文稿页面配置信息
 **/
export const getPageInfoPackInfo = (label_type,page) => request('GET',baseUrlstudy, '/w/page/getIndex/10060039',{
  label_type,page
});

/**
 获取普通课程文稿页面配置信息
 **/
export const getPageInfoPackDetial = (label_type,page) => request('GET',baseUrlstudy, '/w/page/getIndex/10060041',{
  label_type,page
});

/**
 加入计划
 **/
export const joinPlan = (plan_id) => request('GET',ys_baseUrl, '/Plan/freeJoin',{
  plan_id
});

/**
 拆书包作业
 **/
export const packWork = (business_type,business_id,collection_id,chapter_id) => request('GET',order, '/w/pack/work',{
  business_type,business_id,collection_id,chapter_id
});

/**
 获取日历数据 周日历以及月日历
 **/
export const getCalendarData = (type, date, business_name) => request('GET',baseUrl, '/api/yz/study/calendar',{
  type, date, business_name
});

/**
 获取当天课程
 **/
export const getCalendarStudy = (date, business_name) => request('GET', baseUrl, '/api/yz/study/date_learn',{
  date, business_name: business_name || 'yuanzhi'
});

/**
 获取引流弹窗类型
 **/
export const getCourseGuide = (plan_id) => request('GET',ys_baseUrl, '/vk/classroom/get_plan_course_guide',{
    plan_id
});

/**
获取会员信息
**/
export const getYzVipInfo = (user_id, platform_id, privilege_type) => request('GET', baseUrl, '/w/membership/user_info',
privilege_type ? {
    user_id, platform_id, privilege_type
} : {
    user_id, platform_id
});

/**
获取会员特权信息
**/
export const getYzVipPrivilege = () => request('GET', baseUrl, '/api/yz/mkpop/act_privilege_list', {});

 /**
获取会员亲友卡数量
**/
export const getYzGiftCard = () => request('POST', baseUrl, '/w/membership/gift_card', {privilege_type: 'yuanzhi_send_experience_card'});

 /**
领取
 **/
export const cashReceiveSub = (params) => request('POST',ys_baseUrl, '/w/wx_cash_receive/submit',params);
  /**获取微课水印配置
 **/
 export const watermarkConfig = (plan_id) => request('GET',ys_baseUrl, '/vk/classroom/watermark_config',{
    plan_id
});

export const get_course_chapter = (chapter_key) => request('GET',baseUrl, '/w/share/get_course_chapter',{
    chapter_key
});


export const media_info = (params) => request('GET',baseUrl, '/w/media/media_info',params);

/**
微信登录重授权
**/
export const wxAuth = (params) => request('POST', authorizationUrl, '/mp/fwhwechatauth/auth_h5', params);

/**
 * 计划详情
*/
export const plan_detail = (params) => request('GET', baseUrl, '/api/yz/plan/detail', params);

/**
 * 章节列表
*/
export const pack_list = (params) => request('GET', baseUrl, '/api/yz/course/pack_list', params);

/**
 * 章节详情
*/
export const pack_info = (params) => request('GET', baseUrl, '/api/yz/course/pack_info', params);

/**
 * 计划直播列表
*/
export const live_list = (params) => request('GET', baseUrl, '/api/yz/plan/live_list', params);

/**
 * 今日章节列表
*/
export const today_pack_list = (params) => request('GET', baseUrl, '/api/yz/course/today_pack_list', params);

/**
 * 打卡日历
*/
export const plan_calendar = (data) => request('GET', baseUrl, '/w/middle_page/plan_calendar', data);

/**
 * 元知课堂学习数据
*/
export const accomplish = (data) => request('GET', baseUrl, '/w/intensive_reading/accomplish', data);
/**
 * 元知课堂学习数据
*/
export const openDakaMini = (data) => request('POST', baseUrl, '/w/membership/receive_check_money', data);

/*
 年费会员体验卡海报页
 **/
 export const gift_card = () => request('POST', baseUrl, '/w/membership/gift_card', {privilege_type: 'yuanzhi_send_experience_card'});

/**
 14天vip领取记录
**/
export const gift_card_recor = () => request('POST', baseUrl, '/w/membership/gift_card_record', {privilege_type: 'yuanzhi_send_experience_card'});

/**
 * 计划书籍章节更新进度
*/
export const get_pack_count_by_pbid = (data) => request('GET', baseUrl, '/api/yz/course/get_pack_count_by_pbid', data);

/**
 * 计划书籍章节更新进度
*/
export const check_share_data = (params) => request('GET', baseUrl, '/api/yz/check/share_data', params);

/**
 * 用户绑定手机号
*/
export const bind_phone = (params) => request('POST', baseUrl, '/api/yz/user/bind_phone', params);

/**
 * 发验证码
*/
export const sign_msg = (data) => request('GET', baseUrl, '/w/sms/sendCode', data);

/**
 * 计划学习日历
*/
export const study_calendar = (params) => request('GET', baseUrl, '/api/yz/plan/study_calendar', params);

/**
 * 学习日历日历当日章节列表
*/
export const calendar_pack_list = (params) => request('GET', baseUrl, '/api/yz/course/calendar_pack_list', params);

/**
 * 获取计划的商品信息
*/
export const goods_info = (params) => request('GET', baseUrl, '/api/yz/plan/goods_info', params);

/**
 * 获取当前章节上一章节下一章节
*/
export const pack_prev_next = (params) => request('GET', baseUrl, '/api/yz/course/pack_prev_next', params);

/**
 * 获取日历数据 周日历以及月日历
*/
export const get_user_clock_calendar = (params) => request('GET', baseUrl, '/vk/course/get_user_clock_calendar', params);

/**
 * 登陆-发送信息
 * 接口文档地址：无
 * Request
 * @param phone <Int> 手机号
 **/
export const loginSendMsg = (phone) => request('POST', ys_baseUrl, '/MobileLogin/send_msg', {
    phone
})

/**
 * 登陆-检测验证码
 * 接口文档地址：无
 * Request
 * @param phone <Int> 手机号
 * @param code <Int> 验证码
 **/
export const loginCheckCode = (phone, code) => request('POST', ys_baseUrl, '/MobileLogin/checkCode', {
    phone,
    code
})

/**
 * 登陆-检测验证码
 * 接口文档地址：无
 * Request
 * @param phone <Int> 手机号
 * @param code <Int> 验证码
 **/
export const apiPhoneLogin = (phone, code, channel) => request('GET', ys_baseUrl, '/Login/mobileLoginToCookie', {
    phone,
    code,
    channel
})

/**
 * 是否加入项目及项目默认小课
*/
export const projectIsJoin = (params) => request('GET', baseUrl, '/api/yz/course/is_join', params);

/**
 * 计划是否有正在直播
*/
export const getPlanLiving = (params) => request('GET', baseUrl, '/api/yz/course/living_data', params);

/**
 * 获取短视频列表
*/
export const getShortVideoList = (params) => request('GET', baseUrl, '/api/short_video/list', params);

/**
 * 获取计划作业列表
*/
export const getPlanWorkList = (params) => request('GET', baseUrl, '/api/yz/work/list', params);

/**
 * 获取短视频详情
*/
export const getShortVideoDetail = (params) => request('GET', baseUrl, '/api/short_video/detail', params);

/**
 * 短视频点赞/分享计数
*/
export const videoCountHandler = (params) => request('POST', baseUrl, '/api/business/counter', params);
